// eslint-disable-next-line import/prefer-default-export
export const excitedAgeGroups = [
  { label: 'High School', value: 'Highschool' },
  { label: 'Post Secondary', value: 'Post Secondary' },
  { label: 'No Preference', value: 'No Preference' },
];
